import axios from "axios";
import { toast } from "react-toastify";

const baseURL = "https://ballersapi.ballerslife.co/api/v1/";

export const postRequestNew = async (endpoint, token, data) => {
  try {
    const url = baseURL + endpoint;
    const headers = {
      accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    console.log("helloooo");
    const response = await axios.post(url, data, { headers });
    return response.data;
  } catch (error) {
    toast.error(error.response.data.detail);
    console.log(error);
  }
};
